import { useSyncExternalStore } from 'react';

/**
 * Subscribes to window.matchMedia (client-only). SSR snapshot is false.
 * @param {string} query e.g. '(min-width: 768px)'
 */
export function useMediaQuery(query) {
  return useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query);
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}
